// import React, { useState, useEffect, Fragment } from "react";
// import { Card, CardContent, Grid, Typography, TextField, Box } from "@mui/material";
// import { Autocomplete } from "@mui/material";
// import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
// import axios from "axios";
// import { setSnackbar } from "../../../components/hooks/snackBar/reducers";
// import { useDispatch } from "react-redux";
// import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
// import dayjs from 'dayjs';
// import moment from "moment";
// import { Helmet } from "react-helmet-async";
// import Logo from "../../../assets/images/logo.jpeg";
// import { useStyle } from "./style";
// import {
//   Avatar
// } from "@mui/material";
// const Dashboard = () => {
//   const classes = useStyle()
//   const [salesdata, setSalesData] = useState(null);
//   const [data, setData] = useState([]);
//   const [reportdata, setReportData] = useState([]);

//   const [filteredData, setFilteredData] = useState([]);
//   const [reportfilteredData, setReportFilteredData] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState(null); 
//   const [dateLimit, setDateLimit] = useState({
//     fromDate : moment().subtract(1 , 'months').format(),
//     // fromDate : moment().subtract(1 , 'months').format(),
//     toDate : moment().format()
//   });
//   const [supplier, setSupplier] = useState([]);
//   // const [cust, setCust] = useState(null);
//   const [cust, setCust] = useState({ id: 0, fullname: "All" }); 
//   const roleId = localStorage.getItem("role_id")

//   const dispatch = useDispatch();

//   const handleChange = (e, name) => {
//     setDateLimit(prev => ({
//       ...prev, 
//       [name]: dayjs(e).format('YYYY-MM-DD') // Only date (no time or timezone part)
//     }));
//   };
//     // Prepare data for the BarChart
//     const chartData = reportfilteredData.map((item) => ({
//       category_name: item.category_name,
//       sold_count: parseInt(item.sold_count),
//       unsold_count: parseInt(item.unsold_count),
//     }));
    
  
//   //   const handleCategoryChange = (event, newValue) => {
//   //     setSelectedCategory(newValue);
    
//   //     if (!newValue) {
//   //       setReportFilteredData(reportfilteredData); // Reset to the original data
//   //     } else {
//   //       const filtered = reportfilteredData.filter(item => item.category_name === newValue);
//   //       setReportFilteredData(filtered);
//   //     }
//   //   };
    
//   // const categoryNames = [...new Set(reportfilteredData.map(item => item.category_name))];
//   const handleCategoryChange = (event, newValue) => {
//     setSelectedCategory(newValue);
  
//     // Show all data when no category is selected
//     if (!newValue) {
//       setReportFilteredData(reportdata); // Reset to the original full list
//     } else {
//       // Filter data based on the selected category
//       const filtered = reportdata.filter(item => item.category_name === newValue);
//       setReportFilteredData(filtered);
//     }
//   };
  
//   // Generate unique category names for the dropdown
//   const categoryNames = [...new Set(reportdata.map(item => item.category_name))];
  
  


//   // Fetch sales data based on date filters and outlet selection
//   useEffect(() => {
//     const payload = {
//       customer: 0,
//       category: 0,
//     };
//     axios.post(`/v1/dashboard/stock/cat/report`, payload)
//       .then(res => {
//         // setReportFilteredData(res.data);
//         setReportData(res.data); // Store the original full dataset
//         setReportFilteredData(res.data); // Initialize filtered data
//       })
//       .catch(err => {
//         dispatch(setSnackbar(true, 'error', err.response?.data?.error || 'Error occurred'));
//       });
//   }, []);
//   useEffect(() => {
//     if (cust && dateLimit.fromDate && dateLimit.toDate) {
//       fetchSalesData(cust.id, dateLimit.fromDate, dateLimit.toDate);
//     }
    
//   }, [cust, dateLimit]);

//   function fetchSalesData(outletId, fromDate, toDate) {
//     const selectedOutletId = outletId || "all";
//     const formattedFromDate = dayjs(fromDate).format('YYYY-MM-DD');
//     const formattedToDate = dayjs(toDate).format('YYYY-MM-DD');
  
//     axios
//       .get(`v1/reports/outlet_sales/outletwise/currentdate?outletid=${selectedOutletId}&fromdate=${formattedFromDate}&todate=${formattedToDate}`)
//       .then((res) => {
//         setSalesData(res.data); // Assuming the response contains sales data.
//       })
//       .catch((err) => {
//         // dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching data"));
//       });
//   }
  
 

//   useEffect(() => {
//     if (salesdata) {
//       const { outletSales = [] } = salesdata;
//       setFilteredData(outletSales); // Set the outlet sales data for the chart

//       // Map the data to chart format
//       const chartDatas = outletSales.map((item) => ({
//         category_name: item.category_name,
//         total_cash_amount: parseFloat(item.total_cash_amount),
//         total_card_amount: parseFloat(item.total_card_amount),
//         total_upi_amount: parseFloat(item.total_upi_amount),
//       }));

//       setData(chartDatas);
//     }
//   }, [salesdata]);
//   console.log(salesdata,"salesdata");
  
//   // Fetch outlet list data
//   function getSupplierData() {
//     axios
//       .get("/v1/outlet/list/1")
//       .then((res) => {
//         setSupplier(res.data);
//       })
//       .catch((err) => {
//         dispatch(setSnackbar(true, "error", err.response.data.error));
//       });
//   }

//   useEffect(() => {
//     getSupplierData();
//     fetchSalesData()
//   }, []);
//   useEffect(() => {
//     console.log(reportfilteredData, "Filtered Data for Chart");
//   }, [reportfilteredData]);
  
//   return (
//     <>
//       <Helmet>
//     <title>Dashboard</title>
//   </Helmet>
//    {roleId != 1 && roleId != 2 ?
//   <Fragment>
//   <Helmet>
//     <title>Dashboard</title>
//   </Helmet>
//   <div className="" style={{ height: "100vh" }}>
//     <div style={{ width: "100%", backgroundColor:'white' }} >
//       <Avatar variant="square" src={Logo} className={classes.logo}/>
//     </div>
//   </div>
//   </Fragment>
//     :
//        <div style={{ padding: "20px" }}>
//        <Typography variant="h5" gutterBottom>Sales Report</Typography>
//        <Grid container spacing={2} className="p-2 pt-2">
//        <Grid item md={3}>
//        <Autocomplete
//         options={categoryNames}
//         value={selectedCategory}
//         onChange={handleCategoryChange}
//         getOptionLabel={(option) => (option ? option : "")} // Handle null/undefined cases
//         renderInput={(params) => <TextField {...params} label="Category" size="small" />}
//         isOptionEqualToValue={(option, value) => option === value}
//         clearOnEscape
//       />
//          </Grid>
//          <Grid item md={3}>
           
//                <Autocomplete
//          size="small"
//          options={[{ id: 0, fullname: "All" }, ...supplier]}  // Include "All" as an option
//          value={cust}  // Set the value to the selected outlet (default is "All")
//          onChange={(e, newValue) => setCust(newValue)}  // Update selected outlet
//          getOptionLabel={(option) => option.fullname}
//          renderInput={(params) => <TextField {...params} label="Select Outlet" />}
//          isOptionEqualToValue={(option, value) => option.id === value.id} // Ensure correct comparison
//        />
//          </Grid>
//          <Grid item md={3}>
//            <LocalizationProvider dateAdapter={AdapterDayjs}>
//              <DatePicker
//                onChange={(e) => handleChange(e, "fromDate")}
//                value={dayjs(dateLimit.fromDate)}
//                format='DD-MM-YYYY'
//                slotProps={{
//                  textField: {
//                    size: "small",
//                    label: 'From',
//                    style: { width: '100%' }
//                  },
//                }}
//              />
//            </LocalizationProvider>
//          </Grid>
//          <Grid item md={3}>
//            <LocalizationProvider dateAdapter={AdapterDayjs}>
//              <DatePicker
//                onChange={(e) => handleChange(e, "toDate")}
//                value={dayjs(dateLimit.toDate)}
//                format='DD-MM-YYYY'
//                slotProps={{
//                  textField: {
//                    size: "small",
//                    label: 'To',
//                    style: { width: '100%' }
//                  },
//                }}
//              />
//            </LocalizationProvider>
//          </Grid>
//        </Grid>
     
//        {/* <Grid container spacing={3}>
//           {Object.entries(salesdata?.overallTotals || {}).length > 0 ? (
//             Object.entries(salesdata?.overallTotals).map(([key, value]) => (
//               <Grid item xs={12} sm={4} md={3} key={key}>
//                 <Card>
//                   <CardContent>
//                     <Typography variant="h6">{key.replace(/_/g, " ").toUpperCase()}</Typography>
//                     <Typography variant="h5" color="primary">
//                       {typeof value === "number" ? value.toLocaleString() : value}
//                    </Typography>
//                   </CardContent>
//                </Card>
//               </Grid>
//             ))
//          ) : (
//            <></>
//            //  <Typography>No overall totals available</Typography>
//           )}
//         </Grid> */}

//         {/* new updated new no data found */}
//         <Grid container spacing={3}>
//   {/* CHANGED: Add check for salesdata and display "No data" card if not present */}
//   {salesdata && Object.entries(salesdata.overallTotals || {}).length > 0 ? (
//     Object.entries(salesdata.overallTotals).map(([key, value]) => (
//       <Grid item xs={12} sm={4} md={3} key={key}>
//         <Card>
//           <CardContent>
//             <Typography variant="h6">{key.replace(/_/g, " ").toUpperCase()}</Typography>
//             <Typography variant="h5" color="primary">
//               {typeof value === "number" ? value.toLocaleString() : value}
//             </Typography>
//           </CardContent>
//         </Card>
//       </Grid>
//     ))
//   ) : (
//     // ADDED: Show "No data" card if state is null or no overallTotals
//     <Grid item xs={12}>
//       <Card>
//         <CardContent>
//           <Typography align="center" color="textSecondary">
//             No data
//               </Typography>
//         </CardContent>
//       </Card>
//     </Grid>
//   )}
// </Grid>
//        {/* Sales Chart Section */}
//        <Grid container spacing={3} className="p-5">
//          <Grid item xs={12}>
//            <Card>
//              <CardContent>
//              <Typography
//            sx={{
//              fontSize: 20,
//              color: "black",
//              fontWeight: "bold",
//              marginBottom: "20px",
//            }}
//          >
//            Sales Reports
//          </Typography>
//                <ResponsiveContainer width="100%" height={400}>
//                  <BarChart data={data}>
//                    <CartesianGrid strokeDasharray="3 3" />
//                    <XAxis dataKey="category_name" />
//                    <YAxis />
//                    <Tooltip />
//                    <Legend />
//                    <Bar dataKey="total_cash_amount" fill="#8884d8" />
//                    <Bar dataKey="total_card_amount" fill="#82ca9d" />
//                    <Bar dataKey="total_upi_amount" fill="#ff7f50" />
//                    {/* <Bar dataKey="total_cash_amount" fill="#877F7D" />
//                    <Bar dataKey="total_card_amount" fill="#BEBDB8" />
//                    <Bar dataKey="total_upi_amount" fill="#999DA0" /> */}
//                  </BarChart>
//                </ResponsiveContainer>
//              </CardContent>
//            </Card>
//          </Grid>
//          <Grid item xs={12}>
//          <Typography
//            sx={{
//              fontSize: 20,
//              color: "black",
//              fontWeight: "bold",
//              marginBottom: "20px",
//            }}
//          >
//            Stock Category Reports
//          </Typography>
//            <ResponsiveContainer width="100%" height={400}>
//              <BarChart data={chartData}>
//                <CartesianGrid strokeDasharray="3 3" />
//                <XAxis dataKey="category_name" />
//                <YAxis />
//                <Tooltip />
//                <Legend />
//                <Bar dataKey="sold_count" fill="#266774" name="Sold" />
//                <Bar dataKey="unsold_count" fill="#00eed0" name="Unsold" />
//              </BarChart>
   
 
//            </ResponsiveContainer>
//            </Grid>
//        </Grid>
//      </div>
//   }
//     </>
//   );
// };

// export default Dashboard;

import React, { useState, useEffect, Fragment } from "react";
import { Card, CardContent, Grid, Typography, TextField, Box } from "@mui/material";
import { Autocomplete } from "@mui/material";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import axios from "axios";
import { setSnackbar } from "../../../components/hooks/snackBar/reducers";
import { useDispatch } from "react-redux";
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import moment from "moment";
import { Helmet } from "react-helmet-async";
import Logo from "../../../assets/images/logo.jpeg";
import { useStyle } from "./style";
import {
  Avatar
} from "@mui/material";
const Dashboard = () => {
  const classes = useStyle()
  const [salesdata, setSalesData] = useState(null);
  const [data, setData] = useState([]);
  const [reportdata, setReportData] = useState([]);

  const [filteredData, setFilteredData] = useState([]);
  const [reportfilteredData, setReportFilteredData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null); 
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1 , 'months').format(),
    // fromDate : moment().subtract(1 , 'months').format(),
    toDate : moment().format()
  });
  const [supplier, setSupplier] = useState([]);
  // const [cust, setCust] = useState(null);
  const [cust, setCust] = useState({ id: 0, fullname: "All" }); 
  const roleId = localStorage.getItem("role_id")

  const dispatch = useDispatch();

  const handleChange = (e, name) => {
    setDateLimit(prev => ({
      ...prev, 
      [name]: dayjs(e).format('YYYY-MM-DD') // Only date (no time or timezone part)
    }));
  };
    // Prepare data for the BarChart
    const chartData = reportfilteredData.map((item) => ({
      category_name: item.category_name,
      sold_count: parseInt(item.sold_count),
      unsold_count: parseInt(item.unsold_count),
    }));
    
  
  //   const handleCategoryChange = (event, newValue) => {
  //     setSelectedCategory(newValue);
    
  //     if (!newValue) {
  //       setReportFilteredData(reportfilteredData); // Reset to the original data
  //     } else {
  //       const filtered = reportfilteredData.filter(item => item.category_name === newValue);
  //       setReportFilteredData(filtered);
  //     }
  //   };
    
  // const categoryNames = [...new Set(reportfilteredData.map(item => item.category_name))];
  const handleCategoryChange = (event, newValue) => {
    setSelectedCategory(newValue);
  
    // Show all data when no category is selected
    if (!newValue) {
      setReportFilteredData(reportdata); // Reset to the original full list
    } else {
      // Filter data based on the selected category
      const filtered = reportdata.filter(item => item.category_name === newValue);
      setReportFilteredData(filtered);
    }
  };
  
  // Generate unique category names for the dropdown
  const categoryNames = [...new Set(reportdata.map(item => item.category_name))];
  
  


  // Fetch sales data based on date filters and outlet selection
  useEffect(() => {
    const payload = {
      customer: 0,
      category: 0,
    };
    axios.post(`/v1/dashboard/stock/cat/report`, payload)
      .then(res => {
        // setReportFilteredData(res.data);
        setReportData(res.data); // Store the original full dataset
        setReportFilteredData(res.data); // Initialize filtered data
      })
      .catch(err => {
        dispatch(setSnackbar(true, 'error', err.response?.data?.error || 'Error occurred'));
      });
  }, []);
  useEffect(() => {
    if (cust && dateLimit.fromDate && dateLimit.toDate) {
      fetchSalesData(cust.id, dateLimit.fromDate, dateLimit.toDate);
    }
    
  }, [cust, dateLimit]);

  // function fetchSalesData(outletId, fromDate, toDate) {
  //   const selectedOutletId = outletId || "all";
  //   const formattedFromDate = dayjs(fromDate).format('YYYY-MM-DD');
  //   const formattedToDate = dayjs(toDate).format('YYYY-MM-DD');
  
  //   axios
  //     .get(`v1/reports/outlet_sales/outletwise/currentdate?outletid=${selectedOutletId}&fromdate=${formattedFromDate}&todate=${formattedToDate}`)
  //     .then((res) => {
  //       setSalesData(res.data); // Assuming the response contains sales data.
  //     })
  //     .catch((err) => {
  //       // dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching data"));
  //     });
  // }
  
 // changes made 11/9/25
  function fetchSalesData(outletId, fromDate, toDate) {
    const selectedOutletId = outletId || "all";
    const formattedFromDate = dayjs(fromDate).format('YYYY-MM-DD');
    const formattedToDate = dayjs(toDate).format('YYYY-MM-DD');
    axios
      .get(`v1/reports/outlet_sales/outletwise/currentdate?outletid=${selectedOutletId}&fromdate=${formattedFromDate}&todate=${formattedToDate}`)
      .then((res) => {
        if (res.data && !res.data.errors && Object.keys(res.data).length > 0) {
          setSalesData(res.data);
        } else {
          setSalesData(null); // Clear salesdata when no data
          setData([]);        // Also clear chart/table if needed
        }
      })
      .catch((err) => {
        setSalesData(null);   // Clear salesdata on error
        setData([]);          // Also clear chart/table if needed
        // dispatch(setSnackbar(true, "error", err.response?.data?.error || "Error fetching data"));
      });
  }

  // useEffect(() => {
  //   if (salesdata) {
  //     const { outletSales = [] } = salesdata;
  //     setFilteredData(outletSales); // Set the outlet sales data for the chart

  //     // Map the data to chart format
  //     const chartDatas = outletSales.map((item) => ({
  //       category_name: item.category_name,
  //       total_cash_amount: parseFloat(item.total_cash_amount),
  //       total_card_amount: parseFloat(item.total_card_amount),
  //       total_upi_amount: parseFloat(item.total_upi_amount),
  //     }));

  //     setData(chartDatas);
  //   }
  // }, [salesdata]);
   useEffect(() => {
    if (salesdata) {
      const { outletSales = [] } = salesdata;
      setFilteredData(outletSales);
      const chartDatas = outletSales.map((item) => ({
        category_name: item.category_name,
        total_cash_amount: parseFloat(item.total_cash_amount),
        total_card_amount: parseFloat(item.total_card_amount),
        total_upi_amount: parseFloat(item.total_upi_amount),
      }));
      setData(chartDatas);
    }
  }, [salesdata]);
  console.log(salesdata,"salesdata");
  
  // Fetch outlet list data
  function getSupplierData() {
    axios
      .get("/v1/outlet/list/1")
      .then((res) => {
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.data.error));
      });
  }

  useEffect(() => {
    getSupplierData();
    fetchSalesData()
  }, []);
  useEffect(() => {
    console.log(reportfilteredData, "Filtered Data for Chart");
  }, [reportfilteredData]);
  
  return (
    <>
      <Helmet>
    <title>Dashboard</title>
  </Helmet>
   {roleId != 1 && roleId != 2 ?
  <Fragment>
  <Helmet>
    <title>Dashboard</title>
  </Helmet>
  <div className="" style={{ height: "100vh" }}>
    <div style={{ width: "100%", backgroundColor:'white' }} >
      <Avatar variant="square" src={Logo} className={classes.logo}/>
    </div>
  </div>
  </Fragment>
    :
       <div style={{ padding: "20px" }}>
       <Typography variant="h5" gutterBottom>Sales Report</Typography>
       <Grid container spacing={2} className="p-2 pt-2">
       <Grid item md={3}>
       <Autocomplete
        options={categoryNames}
        value={selectedCategory}
        onChange={handleCategoryChange}
        getOptionLabel={(option) => (option ? option : "")} // Handle null/undefined cases
        renderInput={(params) => <TextField {...params} label="Category" size="small" />}
        isOptionEqualToValue={(option, value) => option === value}
        clearOnEscape
      />
         </Grid>
         <Grid item md={3}>
           
               <Autocomplete
         size="small"
         options={[{ id: 0, fullname: "All" }, ...supplier]}  // Include "All" as an option
         value={cust}  // Set the value to the selected outlet (default is "All")
         onChange={(e, newValue) => setCust(newValue)}  // Update selected outlet
         getOptionLabel={(option) => option.fullname}
         renderInput={(params) => <TextField {...params} label="Select Outlet" />}
         isOptionEqualToValue={(option, value) => option.id === value.id} // Ensure correct comparison
       />
         </Grid>
         <Grid item md={3}>
           <LocalizationProvider dateAdapter={AdapterDayjs}>
             <DatePicker
               onChange={(e) => handleChange(e, "fromDate")}
               value={dayjs(dateLimit.fromDate)}
               format='DD-MM-YYYY'
               slotProps={{
                 textField: {
                   size: "small",
                   label: 'From',
                   style: { width: '100%' }
                 },
               }}
             />
           </LocalizationProvider>
         </Grid>
         <Grid item md={3}>
           <LocalizationProvider dateAdapter={AdapterDayjs}>
             <DatePicker
               onChange={(e) => handleChange(e, "toDate")}
               value={dayjs(dateLimit.toDate)}
               format='DD-MM-YYYY'
               slotProps={{
                 textField: {
                   size: "small",
                   label: 'To',
                   style: { width: '100%' }
                 },
               }}
             />
           </LocalizationProvider>
         </Grid>
       </Grid>
     
       {/* <Grid container spacing={3}>
          {Object.entries(salesdata?.overallTotals || {}).length > 0 ? (
            Object.entries(salesdata?.overallTotals).map(([key, value]) => (
              <Grid item xs={12} sm={4} md={3} key={key}>
                <Card>
                  <CardContent>
                    <Typography variant="h6">{key.replace(/_/g, " ").toUpperCase()}</Typography>
                    <Typography variant="h5" color="primary"

                    >
                      {typeof value === "number" ? value.toLocaleString() : value}
                   </Typography>
                  </CardContent>
               </Card>
              </Grid>
            ))
         ) : (
           <></>
           //  <Typography>No overall totals available</Typography>
          )}
        </Grid> */}
        {/* changed 11/9/25 */}
        <Grid container spacing={3}>
  {/* CHANGED: Add check for salesdata and display "No data" card if not present */}
  {salesdata && Object.entries(salesdata.overallTotals || {}).length > 0 ? (
    Object.entries(salesdata.overallTotals).map(([key, value]) => (
      <Grid item xs={12} sm={4} md={3} key={key}>
        <Card>
          <CardContent>
            <Typography variant="h6">{key.replace(/_/g, " ").toUpperCase()}</Typography>
            <Typography variant="h5" color="primary">
              {typeof value === "number" ? value.toLocaleString() : value}
            </Typography>
          </CardContent>
        </Card>
      </Grid>
    ))
  ) : (
    // ADDED: Show "No data" card if state is null or no overallTotals
    <Grid item xs={12}>
      <Card>
        <CardContent>
          <Typography align="center" color="textSecondary">
            No data
              </Typography>
        </CardContent>
      </Card>
    </Grid>
  )}
</Grid>
 {/* changed 11/9/25 */}
       {/* Sales Chart Section */}
       <Grid container spacing={3} className="p-5">
         <Grid item xs={12}>
           <Card>
             <CardContent>
             <Typography
           sx={{
             fontSize: 20,
             color: "black",
             fontWeight: "bold",
             marginBottom: "20px",
           }}
         >
           Sales Reports
         </Typography>
               <ResponsiveContainer width="100%" height={400}>
                 <BarChart data={data}>
                   <CartesianGrid strokeDasharray="3 3" />
                   <XAxis dataKey="category_name" />
                   <YAxis />
                   <Tooltip />
                   <Legend />
                   <Bar dataKey="total_cash_amount" fill="#8884d8" />
                   <Bar dataKey="total_card_amount" fill="#82ca9d" />
                   <Bar dataKey="total_upi_amount" fill="#ff7f50" />
                   {/* <Bar dataKey="total_cash_amount" fill="#877F7D" />
                   <Bar dataKey="total_card_amount" fill="#BEBDB8" />
                   <Bar dataKey="total_upi_amount" fill="#999DA0" /> */}
                 </BarChart>
               </ResponsiveContainer>
             </CardContent>
           </Card>
         </Grid>
         <Grid item xs={12}>
         <Typography
           sx={{
             fontSize: 20,
             color: "black",
             fontWeight: "bold",
             marginBottom: "20px",
           }}
         >
           Stock Category Reports
         </Typography>
           <ResponsiveContainer width="100%" height={400}>
             <BarChart data={chartData}>
               <CartesianGrid strokeDasharray="3 3" />
               <XAxis dataKey="category_name" />
               <YAxis />
               <Tooltip />
               <Legend />
               <Bar dataKey="sold_count" fill="#266774" name="Sold" />
               <Bar dataKey="unsold_count" fill="#00eed0" name="Unsold" />
             </BarChart>
   
 
           </ResponsiveContainer>
           </Grid>
       </Grid>
     </div>
  }
    </>
  );
};

export default Dashboard;